import React from "react";

const AnnouncementModal = ({showModal, handleCloseModal, data}) => {
    return (
        <>
            {showModal && (
                <div className="modal fade show announcement-modal modal-lg" style={{ display: "block" }} tabIndex="-1" 
                    role="dialog" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header d-flex justify-content-between align-items-center">
                                <h5 className="modal-title mt-1">🚨 Important Announcement</h5>
                                <button type="button" className="btn btn-lg btn-close text-danger" aria-label="Close"
                                    onClick={() => handleCloseModal(data.id)}
                                > 
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="modal-title text-primary mb-2">{data.subject || "Welcome to EMS"}</h5>
                                    <i className="text-dark">Date : <span className="text-muted text-end">{(data.date).split(',')[0]}</span></i>
                                </div>
                                <p className="mt-2 text-dark" dangerouslySetInnerHTML={{ __html: data.message || 
                                    "We are glad to have you on board. Please explore the system and let us know if you have any questions." }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
}

export default AnnouncementModal;